import { Inject, Injectable } from '@angular/core';
import { RestService } from './rest.service';
import { config, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { OpenPopupService } from './open-popup.service';
import { APP_CONFIG } from './config-injection';
import { AppConfig } from '../../_api';

@Injectable({
  providedIn: 'root',
})
export class DownloadSecureFileService {
  constructor(
    @Inject(APP_CONFIG) public config: AppConfig,
    private rest: RestService,
    private openPopupService: OpenPopupService
  ) {}

  downloadFile(url: string, postData: any = null): Observable<any> {
    if (postData) {
      return this.rest.postResource(url, postData).pipe(
        map((token) => {
          const url =
            `${this.config.environment.api}DownloadFile?token=` + token;
          this.openPopupService.openPopup(url);
          return true;
        })
      );
    } else {
      return this.rest.getResource(url).pipe(
        map((token) => {
          const url =
            `${this.config.environment.api}DownloadFile?token=` + token;
          this.openPopupService.openPopup(url);
          return true;
        })
      );
    }
  }

  // FUTURE: Rename this service / file... by the filename it looks like we're dealing
  // only w secured files, but this method contradicts that.
  downloadFileUnsecured(url: string): void {
    const fullUrl = this.config.environment.api + url;
    this.openPopupService.openPopup(fullUrl);
  }
}
